import Skeleton from '@/common/components/skeleton/Skeleton';
import { STORIES_BAR_SKELETON_COUNT } from '../utils/storyBar.constants';
import {
	StoryButton,
	StoryRing,
	StoryRingMedia,
} from '../storiesBar.styles';

const StoriesBarSkeleton = () => (
	<>
		{Array.from({ length: STORIES_BAR_SKELETON_COUNT }).map((_, index) => (
			<StoryButton key={index} as="div" aria-hidden="true">
				<StoryRing as="span">
					<StoryRingMedia>
						<Skeleton
							width="100%"
							height="100%"
							radius="50%"
							minWidth="100%"
							minHeight="100%"
						/>
					</StoryRingMedia>
				</StoryRing>
				<Skeleton width="56px" height="12px" radius="6px" minHeight="12px" />
			</StoryButton>
		))}
	</>
);

export default StoriesBarSkeleton;
